import UiElement from '../../../shared/ui-element/ui-element';
import streamText from '../../utils/streaming-text';

import analytics, { events } from '../../../shared/analytics';

import './web-assistant-input.scss';

class WebAssistantInput extends UiElement {
  formClass = '.js-assistant-form';
  onSubmit: (value: string) => void;

  uiCollections = {
    forms: this.formClass,
    clearButtons: '.js-clear-btn',
    helperDescriptions: '.js-assistant-helper-description',
    helperTitles: '.js-assistant-helper-title',
  }

  events = {
    'click @uiCollections.clearButtons': 'handleClearButton',
    'submit @uiCollections.forms': 'handleFormSubmit',
  }

  constructor(parentSelector: string, onSubmit: (value: string) => void) {
    super({ rootElement: parentSelector });

    this.onSubmit = onSubmit;
  }

  onInit() {
    super.onInit();

    const promises: Promise<void>[] = [];

    const descriptionTitles = this.uiCollections.helperTitles as unknown as HTMLParagraphElement[];
    const descriptionElems = this.uiCollections.helperDescriptions as unknown as HTMLParagraphElement[];

    for (const element of descriptionTitles) {
      const { text = '' } = element.dataset;

      promises.push(streamText({ text, element }));
    }

    Promise.all(promises).then(() => {
      for (const element of descriptionElems) {
        const { text = '' } = element.dataset;

        streamText({ text, element });
      }
    });
  }

  handleClearButton(event) {
    const clearButton = event.target as unknown as HTMLButtonElement;
    const form = clearButton.closest(this.formClass) as HTMLFormElement | null;

    analytics.trackEvent(events.WEB_ASSISTANT_RESET);

    form?.reset();
  }

  handleFormSubmit(event) {
    event.preventDefault();

    if (event.target.dataset.eventLabel) {
      analytics.trackEvent({
        ...events.WEB_ASSISTANT_OPEN,
        eventLabel: event.target.dataset.eventLabel,
      });
    }

    const form = event.target as unknown as HTMLFormElement;
    const value = new FormData(form).get('web-assistant-input') as string;

    if (value.length === 0) {
      return;
    }

    this.onSubmit(value);

    analytics.trackEvent({
      ...events.WEB_ASSISTANT_QUERY,
      eventLabel: value,
    });

    form.reset();
  }
}

export default WebAssistantInput as UiElement;
